<template>
    <v-container v-if="evento_id">
        <div class="d-flex justify-space-between align-center mb-2">
            <h3>Preguntas del evento</h3>
            <v-btn color="primary" small @click="nuevaPregunta">
                <v-icon left small>add</v-icon> Nueva pregunta
            </v-btn>
        </div>

        <PreguntasTabla ref="tabla" :evento-id="evento_id" @editar="editarPregunta" />
        <PreguntaDialog ref="dialog" :evento-id="evento_id" @guardado="reload" />
    </v-container>
</template>

<script>
import PreguntasTabla from './components/PreguntasTabla.vue';
import PreguntaDialog from './components/PreguntaDialog.vue';

export default {
    name: 'PreguntasEvento',
    components: { PreguntasTabla, PreguntaDialog },
    data() {
        return {
            evento_id: null,
        };
    },
    mounted() {
        this.evento_id = this.$route.params.id;
    },
    methods: {
        nuevaPregunta() {
            this.$refs.dialog.abrirNueva();
        },
        editarPregunta(pregunta) {
            this.$refs.dialog.abrirEdicion(pregunta);
        },
        reload() {
            this.$refs.tabla.loadData();
        },
    },
};
</script>
